import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    getWidgetEvents,
    updateCommonStoreWsData,
    stopListeningForUpdates,
} from '~shared/components/react/CommonDataListEvents/actions/commonDataListEventsActions';
import {
    clearCommonStore,
} from '~shared/components/react/CommonDataStore/actions';

const useOddsBoostEvents = (postUrl, sportSlug, lazyLoadHasLoaded) => {
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const postParams = {
            sportSlug,
        };
        dispatch(getWidgetEvents(
            updateCommonStoreWsData,
            postUrl,
            postParams,
            {},
            true
        )).then(() => {
            setIsLoading(false);
            lazyLoadHasLoaded();
        });

        return () => {
            dispatch([
                stopListeningForUpdates(),
                clearCommonStore(),
            ]);
        };

    }, [sportSlug]);

    return isLoading;
};

export default useOddsBoostEvents;
